export default __webpack_public_path__ + "static/media/AL.7f7b7668.svg";